export default __webpack_public_path__ + "static/media/contact2.e59c094e.JPG";